export const MenuIdPeople = 'PEOPLE' as const;
